import { ACTIONS } from 'a/pictureThis/data/constants';
import * as fromCurriculum from 'a/pictureThis/content/curriculum';

const draggableTexts = (state = [], { type, payload }) => {
  switch (type) {
    case ACTIONS.CREATE_VIEW_MODEL_FROM_CONTENT:
      return createDraggableByPage(payload);
    default:
      return state;
  }
};

const createDraggableByPage = (payload) => {
  const script = fromCurriculum.getStoryScript(payload.levelIndex, payload.contentIndex);
  let nextState = [];
  let runningGroupId = 0;
  script.forEach((page) => {
    nextState = [...nextState, createDraggables(page, runningGroupId)];
    runningGroupId += page.length;
  });
  return nextState;
};

let nextDraggableKey = 0;
const createDraggables = (script, runningGroupId) => {
  const phrasesWithGroupId = assignGroupIdToPhrases(script, runningGroupId);
  const individualWords = breakDownIntoIndividualWords(phrasesWithGroupId);
  return individualWords;
};

const assignGroupIdToPhrases = (script, runningGroupId) => {
  let id = runningGroupId;
  return script.map(phrase =>
    ({ ...phrase, groupId: id++ }));
};

const breakDownIntoIndividualWords = (draggablesWithGroupId) => {
  const fragments = [];
  for (let i = 0; i < draggablesWithGroupId.length; i++) {
    const individualWords = draggablesWithGroupId[i].text.match(/\S+/g);
    for (let k = 0; k < individualWords.length; k++) {
      fragments.push({
        ...draggablesWithGroupId[i],
        text: individualWords[k],
        key: nextDraggableKey++,
        id: i,
        isDragging: false,
        isFirstWordInSentence: individualWords[0] === individualWords[k],
        ariaLabel: individualWords[0] === individualWords[k] ? draggablesWithGroupId[i].text : '',
        isLastWordInSentence: individualWords[individualWords.length - 1] === individualWords[k],
      });
    }
  }
  return fragments;
};

export default draggableTexts;

export const getDraggablesTextsByPage = (state, page) => {
  if (state[page]) {
    return state[page];
  }
  return [];
};
